module.exports={close:"Sulje",error:"Virhe",info:"Tiedot",success:"Onnistui",warning:"Varoitus"};